import useSWR from 'swr';
import type User from '@/types/api/User';
import { fetcherWithDataKey } from '@/utils/services';
import useOwnerOrgId from '../useOwnerOrgId';

const useUser = (userId: string | null = null) => {
  const ownerOrgId = useOwnerOrgId();
  const key =
    userId && ownerOrgId ? `orgs/${ownerOrgId}/users/${userId}` : null;
  return useSWR<User>(key, fetcherWithDataKey('user'));
};

export default useUser;
